import { useState } from 'react';
import { Link } from 'react-router-dom';

import './navigation.scss';

function Navigation(props) {
  const [open, setOpen] = useState(false);

  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     open: false
  //   };

  //   this.toggleNavigation = this.toggleNavigation.bind(this);
  // }

  // toggleNavigation() {
  //   this.setState({ open: !this.state.open });
  // }

  const renderLinks = () => {
    const links = props.links.map((link, index) => {
      return (
        <div className="c-navigation--link" key={index}>
          <Link to={link.url} onClick={() => setOpen(false)}>{link.title}</Link>
        </div>
      );
    });

    links.unshift(
      <div className="c-navigation--arrow" key="icon">
        <i className="material-icons" onClick={() => setOpen(!open)}>{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
      </div>
    );

    return links;
  }

  // componentDidMount() {
  //   window.scrollTo(0, 0);
  // }

  return (
    <div className={`c-navigation${open ? '--open' : '' }`}>
      {renderLinks()}
    </div>
  );
}

export default Navigation;
